:host {
  --menu-max-height: 358px;
  --section-min-width: 200px;
  --section-max-width: 200px;
}
.wrapper {
  display: flex;
  flex-direction: column;
  max-height: var(--menu-max-height);
  padding-bottom: 6px;
  position: relative;
  background: var(--white-layout-301-level-0-elevation);

  .search-container {
    position: absolute;
    width: 100%;
    top: 0;
    z-index: 1;
    background-color: var(--white-layout-301-level-0-elevation);
    padding: calc(var(--spacer) * 1.5);
  }

  .scrollable-container {
    position: relative;
    display: flex;
    flex-direction: column;
    overflow: auto;
    padding: calc(var(--spacer) * 1.5);
    --separator-color: var(--chart-101-pressed-dividers);
    --pressed-color: var(--chart-100-pressed);
    --hover-color: var(--chart-051-hover);

    &.has-search-bar {
      padding-top: 0;
      margin-top: calc(var(--spacer) * 7.5); // the height of .search-container + its padding and margin
    }

    .quick-actions {
      margin-bottom: calc(var(--spacer) * 2);

      .quick-actions-header {
        line-height: 1.2;
        color: var(--chart-300-icon-buttons);
        padding: calc(var(--spacer) + 1px) 0 calc(var(--spacer) + 1px) calc(var(--spacer) + 2px);
        --font-family: 'Montserrat', sans-serif;
      }

      .sections .section::after {
        // no border between quick action sections
        display: none;
      }
    }

    .section-headers {
      position: sticky;
      z-index: 1;
      top: 0;
      display: flex;
      width: 100%;

      .section-header {
        &.disabled {
          pointer-events: none;
          gz-icon {
            opacity: 0.5;
            &::part(svgIcon) {
              fill: var(--grey-layout-200-disabled);
            }
          }
          span {
            color: var(--grey-layout-200-disabled);
          }
        }

        flex: 1;
        display: flex;
        align-items: center;
        gap: var(--spacer);
        font-weight: 600;
        color: var(--body-text-arrows-400);
        background-color: var(--white-layout-301-level-0-elevation);

        gz-icon {
          margin: calc(var(--spacer) * 0.5);
        }
      }
    }

    .sections {
      display: flex;

      .no-results {
        position: absolute;
        z-index: 1;
        top: var(--spacer);
        color: var(--main-titles-inputs-600);
        font-family: var(--font-family-secondary);
      }

      .section {
        flex: 1;
        position: relative;
        display: flex;
        flex-direction: column;

        .item {
          padding: var(--spacer) calc(var(--spacer) + 2px);
          cursor: pointer;
          appearance: none;
          color: var(--main-titles-inputs-600);
          background-color: transparent;
          border: none;
          margin: 0;
          font: inherit;
          text-align: inherit;
          outline: none;

          .item-icon {
            position: absolute;
            right: 0;
            top: 0;
            bottom: 0;
            display: block;
          }

          gz-tooltip {
            width: 100%;
            margin-top: 0;
            line-height: 1.5;
            user-select: none;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-family: var(--font-family-secondary);
            font-size: var(--body-size-medium);

            &.has-icon {
              padding-right: calc(var(--spacer) * 3);
            }
          }

          &[disabled] {
            cursor: default;
            color: var(--grey-layout-200-disabled);
            background-color: unset;
          }

          &:hover:not([disabled]) {
            background-color: var(--hover-color);
          }

          &:active:not([disabled]) {
            background-color: var(--pressed-color);
          }

          &:focus-visible:not([disabled]) {
            padding: calc(var(--spacer) - 1px) calc(var(--spacer) + 1px);
            border: 1px solid var(--blue-layout-500-focus);
          }
        }

        &.border::after {
          /* this is the border between each section */
          position: absolute;
          content: '';
          height: calc(100% - var(--spacer));
          right: var(--spacer);
          top: var(--spacer);
          border-right: 1px solid var(--separator-color);
        }
      }
    }

    .section,
    .section-header {
      min-width: var(--section-min-width);
      max-width: var(--section-max-width);
      box-sizing: content-box;

      &:not(:last-child) {
        padding-right: calc(var(--spacer) * 2);
      }
    }

    .section .item,
    .section-header,
    .quick-actions-header {
      height: calc(var(--spacer) * 4);
    }
  }
}
